import React from 'react';

const Icon = ({ imageName, iconLink, iconName }) => {
  return (
    <div className='card'>
      <a href={iconLink} onClick={() => handleIconClick(iconName)}>
        <img src={imageName} alt={iconName} />
      </a>
      <a href={iconLink} onClick={() => handleIconClick(iconName)}>
        {iconName}
      </a>
    </div>
  );
};

function handleIconClick(iconName) {
  // You can add your logic to handle the click event here
  console.log(`Clicked on ${iconName}`);
}

export default Icon;
